import axios from "axios";
import { ip_back } from "../config";

const headers = () => ({
  headers: { Authorization: localStorage.getItem("token") },
});

function unwrap(response) {
  const body = response.data || {};
  if (body.status === "error" || body.status === "pending_access") {
    const error = new Error(body.message || "Request failed");
    error.status = body.status;
    throw error;
  }
  return body.data;
}

async function postFftt(path, payload) {
  try {
    const response = await axios.post(`${ip_back}api/admin${path}`, payload, headers());
    return unwrap(response);
  } catch (error) {
    const body = error.response?.data;
    if (body?.message) {
      const wrapped = new Error(body.message);
      wrapped.status = body.status;
      throw wrapped;
    }
    throw error;
  }
}

export async function previewFfttRoster(clubId) {
  return postFftt("/fftt/roster", { club_id: clubId });
}

export async function linkFfttLicence(payload) {
  return postFftt("/fftt/linkLicence", payload);
}

export async function prefillFfttTeams(clubId) {
  return postFftt("/fftt/prefillTeams", { club_id: clubId });
}
